module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/e6HCx4/tc-custom/FC-9781528967587.jpg?1685327561096?1731166562867",
      "alt": "This image is the cover for the book Another Time"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Another Time\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Set in three continents, over an eighty-year span, this is a story of loss, guilt, shame, deception, love and the ultimate struggle for survival. Unable to accept his lot in life, in the midst of the desolate anddesperate backdrop of Siberia, Stefan Jablonski plunges into a destructive spiral of betrayal and deceit. The silver pocket watch, given to him during his immigrant days in America, and always worn close to his heart, gives him comfort; but what secret link does it have with the past and why will it play such a prolific role in the life of his daughter, Magdallena, and that of future generations? How will the past, present and future interlink and how will time set the fate of generations?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Antonina Irena Brzozowska\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Antonina Irena Brzozowska was born, grew up and was educated in the north of England. Coming from Polish extraction, she has a strong interest in the culture and traditions of Poland. Currently, a supply teacher she has taken immense pleasure in writing, reading and travelling.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0